import { CALENDAR_TYPES } from '@/views/constants'

/*
  original calendar locations,
  collects as "simple" calendar info, inside Calendar entity constructor
 */
export default class CalendarOriginalLocations {
  constructor (options = {}, locationId = 0, calendarType = CALENDAR_TYPES.PRACTICE_TYPE) {
    this.list = this.getLocations(options, calendarType).filter(l => l).map(l => {
      const name = l.address1 || `${l.address_number || ''} ${l.address_street || ''}`.trim() || ''
      return {
        id: l.id,
        internalName: l.name,
        city: l.city,
        address1: l.address1,
        address2: l.address2,
        addressNumber: l.address_number,
        addressStreet: l.address_street,
        state: l.state,
        zip: l.zip,
        name: name,
        text: name,
        addressLine: `${name}, ${l.city}, ${l.state || ''} ${l.zip || ''}`,
        sortId: l.sort_id
      }
    })
    this.current = this.getCurrentLocationFromArray(locationId, this.list) || null
  }

  getLocations (options, type) {
    if ([CALENDAR_TYPES.PROVIDER_LOCATION_TYPE, CALENDAR_TYPES.LOCATION_TYPE].includes(type)) {
      return [options.location]
    } else if (CALENDAR_TYPES.PROVIDER_TYPE === type) {
      return (options?.doctor?.doctor_locations || []).flatMap(docLocs => docLocs.location)
    } else if (CALENDAR_TYPES.PRACTICE_TYPE === type) {
      if (options?.practice?.doctors) {
        const locations = []
        const locationIds = new Set()
        options.practice.doctors.forEach((doctor) => {
          const currentLocations = doctor.doctor_locations.flatMap(docLocs => docLocs.location)
          currentLocations.forEach((location) => {
            if (!locationIds.has(location.id)) {
              locationIds.add(location.id)
              locations.push(location)
            }
          })
        })
        return locations
      } else if (options?.practice?.locations) {
        return options?.practice?.locations
      }
    }
    return []
  }

  getCurrentLocationFromArray (locationId, locationArray) {
    return locationArray.find(location => +location.id === +locationId)
  }
}
